<template>
    <div class="monitoring-point">
        <Tabs :activeCom.sync="activeCom" :tabs="tabs" />
        <!-- 因为需要共用左侧 所以这里手动实现一下 -->
        <div class="main-content uk-flex">
            <!-- 因为这里LeftContent如果完全相同的话会被diff算法认为是同一个组件 而不会重新渲染 需求要求的是两个Left都是分别独立的 -->
            <template v-if="activeCom === 'RealSituation'">
                <CarrierList :getList="getMonitorPoint" :path="ltfPath" :getSave="'result.carrierMonitorList'" :key="1"></CarrierList>
                <!-- <LeftContent key="RealSituation" tab="RealSituation"></LeftContent> -->
                <DisplayArea style="width:calc(100% - 300px)"></DisplayArea>
            </template>

            <template v-if="activeCom === 'DataAnalysis'">
                <CarrierList :getList="getMonitorPoint" :path="ltfPath" :getSave="getSaved" :key="2"></CarrierList>
                <DataAnalysis style="width:calc(100% - 300px)"></DataAnalysis>
            </template>
        </div>
    </div>
</template>

<script>
import Tabs from '../deviceMonitor/components/Tabs.vue';

// 实时情况展示区
import DisplayArea from './component/DisplayArea/DisplayArea.vue';
// 数据分析展示区
import DataAnalysis from './component/DataAnalysis/DataAnalysis.vue';

import CarrierList from '@/components/CarrierList/CarrierList.vue';
import { getMonitorPoint, getSaved } from '@/api/modules/monitorPoint';

export default {
    components: {
        Tabs,
        DisplayArea,
        DataAnalysis,
        CarrierList
    },
    data() {
        return {
            tabs: [
                {
                    label: $t('integration.real_time_situation'),
                    name: 'RealSituation'
                },
                {
                    label: $t('integration.data_analysis'),
                    name: 'DataAnalysis'
                }
            ],
            activeCom: 'RealSituation',
            monitorPoint: [],
            ltfPath: {
                listPath: 'result.page.result'
            }
        };
    },
    computed: {
        getMonitorPoint: () => getMonitorPoint,
        getSaved: () => getSaved
    },
    methods: {
        // 获取转发平台  后面显示转发平台需要用到
        getForward() {
            this.$store.dispatch('forward/forward');
        }
    },
    mounted() {
        this.getForward();
    }
};
</script>

<style lang="scss" scoped>
.monitoring-point {
    width: 100%;
    height: calc(100%);
    padding: 15px;
    box-sizing: border-box;
    .main-content {
        height: calc(100% - 56px);
        width: 100%;
    }
}
</style>
